export default {
  dbi_range_month_picker_launch: '发行后',
  dbi_range_release_date_picker_launch: '发行后',
  dbi_range_month_picker_please_enter_correct_date: '请输入正确的日期',
  dbi_range_month_picker_over_max_date: '日期超出范围',
  dbi_range_month_picker_over_365_dates: '日期应该小于365天',
};
